/* Happy Valley Seeds: the Learning Hub shell, version 4, 5 October 2026.
   Hub rail disclosure on narrow screens, the On this page list, the current heading mark, tables made readable
   on a phone, on a topic page the tag select and the rest of the A to Z, the rail's guide counts past the
   store's first 250 pages, and the zone tables without their cities column. Loaded deferred by
   sections/main-blog-post.liquid (an article) and snippets/hvs-shell.liquid (every other Learning Hub page).
   Nothing here changes layout after first paint except on a tap, or when the reader asks for the rest of a list. */
(function () {
  'use strict';
  var root = document.querySelector('[data-hvs-article], [data-hvs-shell]');
  if (!root) { return; }
  var narrowRail = window.matchMedia ? window.matchMedia('(max-width: 999px)') : null;
  var narrowOtp = window.matchMedia ? window.matchMedia('(max-width: 1279px)') : null;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. Hub rail: one button under the breadcrumb opens the rail in place on phones and tablets. */
  var rail = root.querySelector('[data-art-rail]');
  if (rail) {
    var railBtn = rail.querySelector('[data-art-rail-toggle]');
    var railNav = rail.querySelector('[data-art-rail-nav]');
    if (railBtn && railNav) {
      function setRail(open) {
        railNav.hidden = !open;
        railBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      railBtn.addEventListener('click', function () { setRail(railNav.hidden); });
      function syncRail() {
        if (!narrowRail) { return; }
        if (narrowRail.matches) { setRail(false); } else { setRail(true); }
      }
      if (narrowRail) {
        syncRail();
        if (narrowRail.addEventListener) { narrowRail.addEventListener('change', syncRail); }
        else if (narrowRail.addListener) { narrowRail.addListener(syncRail); }
      }
    }
  }

  /* 2. On this page: ids on the h2 headings, matched to the list printed by Liquid. */
  var content = root.querySelector('.article__content');
  var otp = root.querySelector('[data-art-otp]');
  var heads = content ? content.querySelectorAll('h2') : [];
  var n = 0;
  for (var i = 0; i < heads.length; i++) {
    n += 1;
    if (!heads[i].id) { heads[i].id = 'art-h2-' + n; }
    heads[i].setAttribute('tabindex', '-1');
  }
  if (otp) {
    var otpBtn = otp.querySelector('[data-art-otp-toggle]');
    var otpList = otp.querySelector('[data-art-otp-list]');
    if (otpBtn && otpList) {
      function setOtp(open) {
        otpList.hidden = !open;
        otpBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      otpBtn.addEventListener('click', function () { setOtp(otpList.hidden); });
      function syncOtp() {
        if (!narrowOtp) { return; }
        if (narrowOtp.matches) { setOtp(false); } else { setOtp(true); }
      }
      if (narrowOtp) {
        syncOtp();
        if (narrowOtp.addEventListener) { narrowOtp.addEventListener('change', syncOtp); }
        else if (narrowOtp.addListener) { narrowOtp.addListener(syncOtp); }
      }
      /* A tap on a link in the open phone list closes the list, so the heading is in view. */
      otpList.addEventListener('click', function (e) {
        var a = e.target && e.target.closest ? e.target.closest('a') : null;
        if (a && narrowOtp && narrowOtp.matches) { setOtp(false); }
      });
    }
    /* The current heading, marked with a class only. Never changes a row's size. */
    var links = otp.querySelectorAll('a[href^="#"]');
    if (links.length && heads.length && 'IntersectionObserver' in window) {
      var byId = {};
      for (var k = 0; k < links.length; k++) { byId[links[k].getAttribute('href').slice(1)] = links[k]; }
      var current = null;
      function mark(id) {
        if (current === id) { return; }
        if (current && byId[current]) { byId[current].classList.remove('is-current'); byId[current].removeAttribute('aria-current'); }
        current = id;
        if (byId[id]) { byId[id].classList.add('is-current'); byId[id].setAttribute('aria-current', 'location'); }
      }
      var headerH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 84;
      var io = new IntersectionObserver(function (entries) {
        for (var e = 0; e < entries.length; e++) {
          if (entries[e].isIntersecting) { mark(entries[e].target.id); }
        }
      }, { rootMargin: (-headerH - 8) + 'px 0px -70% 0px', threshold: 0 });
      for (var h = 0; h < heads.length; h++) { if (byId[heads[h].id]) { io.observe(heads[h]); } }
    }
  }

  /* 3a. Zone tables (the sowing calendar in every guide, and in some articles) carry an "Example cities" column
     that doubles the table's height and squeezes the rest. On the owner's word the column comes out: its cells are
     hidden, and the cities go into one collapsed list under the table, built from those cells, so the content is
     untouched and nothing is lost. The zone chooser at the top of a guide names the cities of the chosen zone too. */
  var zoneTables = root.querySelectorAll('.g-body table, .article__content table');
  for (var zt = 0; zt < zoneTables.length; zt++) {
    var ztab = zoneTables[zt];
    if (ztab.getAttribute('data-hvs-cities')) { continue; }
    var zhead = ztab.tHead ? ztab.tHead.rows[0] : (ztab.rows[0] && ztab.rows[0].querySelector('th') ? ztab.rows[0] : null);
    if (!zhead) { continue; }
    var col = -1;
    for (var zc = 0; zc < zhead.cells.length; zc++) {
      if (/^\s*example\s+cities\s*$/i.test(zhead.cells[zc].textContent)) { col = zc; break; }
    }
    if (col < 0) { continue; }
    ztab.setAttribute('data-hvs-cities', '1');
    zhead.cells[col].hidden = true;
    var pairs = [];
    var zrows = ztab.tBodies.length ? ztab.tBodies[0].rows : ztab.rows;
    for (var zr = 0; zr < zrows.length; zr++) {
      var row = zrows[zr];
      if (row === zhead || row.cells.length <= col) { continue; }
      var zone = row.cells[0].textContent.replace(/\s+/g, ' ').trim();
      var cities = row.cells[col].textContent.replace(/\s+/g, ' ').trim();
      row.cells[col].hidden = true;
      if (zone && cities) { pairs.push([zone, cities]); }
    }
    if (!pairs.length) { continue; }
    var det = document.createElement('details');
    det.className = 'hvs-zone-cities';
    var sum = document.createElement('summary');
    sum.textContent = 'Example cities for each zone';
    det.appendChild(sum);
    var dl = document.createElement('dl');
    for (var zp = 0; zp < pairs.length; zp++) {
      var dt = document.createElement('dt'); dt.textContent = pairs[zp][0];
      var dd = document.createElement('dd'); dd.textContent = pairs[zp][1];
      dl.appendChild(dt); dl.appendChild(dd);
    }
    det.appendChild(dl);
    var host = ztab.parentElement;
    while (host && host.parentElement && /(^|\s)(hvs-table-scroll|table-scroll|table-wrapper|table-container)(\s|$)/.test(host.className)) { host = host.parentElement; }
    var anchor = ztab;
    while (anchor.parentElement && anchor.parentElement !== host) { anchor = anchor.parentElement; }
    anchor.parentNode.insertBefore(det, anchor.nextSibling);
  }

  /* 3. Tables. A wide table scrolls sideways inside its own box; a table with four or more
     columns is stacked into labelled rows on a phone (the stylesheet does the stacking). */
  if (content) {
    var tables = content.querySelectorAll('table');
    for (var t = 0; t < tables.length; t++) {
      var table = tables[t];
      var parent = table.parentElement;
      var wrapped = parent && (parent.classList.contains('table-scroll') || parent.classList.contains('hvs-table-scroll') ||
        parent.classList.contains('table-wrapper') || parent.classList.contains('table-container'));
      if (!wrapped) {
        var wrap = document.createElement('div');
        wrap.className = 'hvs-table-scroll';
        table.parentNode.insertBefore(wrap, table);
        wrap.appendChild(table);
      }
      var headRow = table.tHead ? table.tHead.rows[0] : (table.rows[0] && table.rows[0].querySelector('th') ? table.rows[0] : null);
      if (!headRow) { continue; }
      var labels = [];
      for (var c = 0; c < headRow.cells.length; c++) { labels.push(headRow.cells[c].textContent.replace(/\s+/g, ' ').trim()); }
      var shownCols = 0;
      for (var sc = 0; sc < headRow.cells.length; sc++) { if (!headRow.cells[sc].hidden) { shownCols += 1; } }
      if (shownCols < 4) { continue; }
      table.classList.add('is-stack');
      var bodyRows = table.tBodies.length ? table.tBodies[0].rows : table.rows;
      for (var r = 0; r < bodyRows.length; r++) {
        if (bodyRows[r] === headRow) { continue; }
        for (var d = 0; d < bodyRows[r].cells.length && d < labels.length; d++) {
          if (!bodyRows[r].cells[d].hasAttribute('data-label')) { bodyRows[r].cells[d].setAttribute('data-label', labels[d]); }
        }
      }
    }
    var hints = content.querySelectorAll('.hvs-scroll-hint');
    for (var s = 0; s < hints.length; s++) { hints[s].parentNode.removeChild(hints[s]); }
  }

  /* 4. Jump links: instant by default; smooth only when the reader allows motion. */
  if (!reduce && otp) {
    otp.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href^="#"]') : null;
      if (!a) { return; }
      var target = document.getElementById(a.getAttribute('href').slice(1));
      if (!target || !target.scrollIntoView) { return; }
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (history.replaceState) { history.replaceState(null, '', a.getAttribute('href')); }
      target.focus({ preventScroll: true });
    });
  }

  /* 5. Topic page: the tag select opens the tag's own page (each option's value is that page's address),
     so the filter is a plain list of links without scripts and one change event with them. */
  var tagSel = root.querySelector('[data-tp-tag]');
  if (tagSel) {
    tagSel.addEventListener('change', function () {
      var v = tagSel.value;
      if (v) { window.location.assign(v); }
    });
  }

  /* 6. Topic page, A to Z: Shopify prints at most 50 articles a page. When a topic has more, the page carries a
     "Show the rest" link to the next page; here the next pages are fetched and their rows merged into the letter
     groups in place, each list re-sorted on its data-sort key. Without scripts the link works as a link. */
  var az = root.querySelector('[data-tp-az]');
  var rest = root.querySelector('[data-tp-az-rest]');
  if (az && rest && window.fetch && window.DOMParser) {
    var note = rest.closest ? rest.closest('[data-tp-note]') : null;
    var letters = root.querySelector('[data-tp-letters]');
    var busy = false;
    function sortKey(li) { return (li.getAttribute('data-sort') || '').toLowerCase(); }
    function groupFor(letter) {
      var id = 'az-' + (letter === '#' ? 'other' : letter);
      var g = document.getElementById(id);
      if (g) { return g; }
      g = document.createElement('section');
      g.className = 'tp-az__group';
      g.id = id;
      g.innerHTML = '<h2 class="tp-az__letter"></h2><ul class="tp-az__list"></ul>';
      g.firstChild.textContent = letter;
      var groups = az.querySelectorAll('.tp-az__group');
      var before = null;
      for (var i = 0; i < groups.length; i++) {
        var gl = groups[i].id.slice(3); if (gl === 'other') { gl = ''; }
        if (gl > (letter === '#' ? '' : letter)) { before = groups[i]; break; }
      }
      az.insertBefore(g, before);
      if (letters) {
        var spans = letters.querySelectorAll('span');
        for (var s = 0; s < spans.length; s++) {
          if (spans[s].textContent === letter) {
            var a = document.createElement('a');
            a.href = '#' + id;
            a.textContent = letter;
            spans[s].parentNode.replaceChild(a, spans[s]);
          }
        }
      }
      return g;
    }
    function merge(doc) {
      var rows = doc.querySelectorAll('[data-tp-az] .tp-az__list li');
      var touched = [];
      for (var i = 0; i < rows.length; i++) {
        var li = document.importNode(rows[i], true);
        var g = groupFor(li.getAttribute('data-letter') || '#');
        var ul = g.querySelector('.tp-az__list');
        ul.appendChild(li);
        if (touched.indexOf(ul) < 0) { touched.push(ul); }
      }
      for (var t = 0; t < touched.length; t++) {
        var items = [].slice.call(touched[t].children);
        items.sort(function (a, b) { var ka = sortKey(a), kb = sortKey(b); return ka < kb ? -1 : ka > kb ? 1 : 0; });
        for (var k = 0; k < items.length; k++) { touched[t].appendChild(items[k]); }
      }
      var next = doc.querySelector('[data-tp-az-rest]');
      return next ? next.getAttribute('href') : null;
    }
    function loadRest(url) {
      if (busy) { return; }
      busy = true;
      if (note) { note.setAttribute('aria-busy', 'true'); }
      fetch(url, { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) { throw new Error(r.status); }
        return r.text();
      }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = merge(doc);
        busy = false;
        if (next) { loadRest(next); return; }
        if (note && note.parentNode) { note.parentNode.removeChild(note); }
      }).catch(function () {
        busy = false;
        if (note) { note.removeAttribute('aria-busy'); }
      });
    }
    rest.addEventListener('click', function (e) {
      e.preventDefault();
      loadRest(rest.getAttribute('href'));
    });
    if ('IntersectionObserver' in window && note) {
      var restIo = new IntersectionObserver(function (entries) {
        for (var e = 0; e < entries.length; e++) {
          if (entries[e].isIntersecting) { restIo.disconnect(); loadRest(rest.getAttribute('href')); }
        }
      }, { rootMargin: '400px 0px' });
      restIo.observe(note);
    }
  }

  /* 7. The rail's guide counts. Liquid reads at most 250 pages in one request; the rail prints the count of those and
     how many pages there are. The guides on the later pages come from sections/hvs-guide-more.liquid rendered for the
     Learning Hub page (its index lists each guide's library as "c"), the same index the hub's own script reads. */
  var railList = root.querySelector('[data-art-rail] [data-rail-pages]');
  var railPages = railList ? parseInt(railList.getAttribute('data-rail-pages'), 10) || 1 : 1;
  if (railList && railPages > 1 && window.fetch && window.DOMParser && window.Promise) {
    var railJobs = [];
    for (var pg = 2; pg <= railPages && pg <= 8; pg++) {
      railJobs.push(fetch('/pages/learning-hub?section_id=hvs-guide-more&page=' + pg, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; }));
    }
    Promise.all(railJobs).then(function (htmls) {
      var per = {}, total = 0;
      for (var i = 0; i < htmls.length; i++) {
        if (!htmls[i]) { continue; }
        var doc = new DOMParser().parseFromString(htmls[i], 'text/html');
        var idx = doc.querySelector('[data-guide-index]');
        var list = [];
        try { list = JSON.parse(idx ? idx.textContent : '[]'); } catch (err) { list = []; }
        for (var k = 0; k < list.length; k++) {
          var c = list[k] && list[k].c ? String(list[k].c) : '';
          per[c] = (per[c] || 0) + 1;
          total += 1;
        }
      }
      function bump(el, add) {
        if (!el || !add) { return; }
        el.textContent = String((parseInt(el.textContent, 10) || 0) + add);
      }
      bump(railList.querySelector('[data-rail-guides] [data-rail-n]'), total);
      var libRows = railList.querySelectorAll('[data-rail-lib]');
      for (var q = 0; q < libRows.length; q++) {
        bump(libRows[q].querySelector('[data-rail-n]'), per[libRows[q].getAttribute('data-rail-lib')] || 0);
      }
    });
  }
})();
